import { render, staticRenderFns } from "./distributionConfig.vue?vue&type=template&id=78eb1c1f&scoped=true&"
import script from "./distributionConfig.vue?vue&type=script&lang=js&"
export * from "./distributionConfig.vue?vue&type=script&lang=js&"
import style0 from "./distributionConfig.vue?vue&type=style&index=0&id=78eb1c1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eb1c1f",
  null
  
)

export default component.exports